import React, { useState, useEffect } from 'react';
// import styles from './AdvancedBasicSuperfundNonNPL.module.scss';
import styles from '../../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import { CalciteCheckbox } from '@esri/calcite-components-react';

/*
the options object stores objects with attributes for:
  - what to label the checkbox with
  - what parameter to query for when a box is checkbox
  - the objectIds returned from the query (query is only done the first time the box is checked)
*/
const options = {
  "Additional Assessment Needed/Ongoing": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Additional Assessment Needed/Ongoing'",
    isIncluded: false,
    objectIds: null
  },
  "Initial Assessment Needed/Ongoing": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Initial Assessment Needed/Ongoing'",
    isIncluded: false,
    objectIds: null
  },
  "Status not specified": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Status not specified'",
    isIncluded: false,
    objectIds: null
  },
  "Not Eligible for the NPL": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Not Eligible for the NPL/No Further Remedial Action Planned'",
    isIncluded: false,
    objectIds: null
  },
  "Deferred to Nuclear Regulatory Commission": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Deferred to Nuclear Regulatory Commission'",
    isIncluded: false,
    objectIds: null
  },
  "Deferred to RCRA Subtitle C Program": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Deferred to RCRA Subtitle C Program'",
    isIncluded: false,
    objectIds: null
  },
  "Long-term Cleanup Attention Needed/Ongoing under EPA Enforcement Authority": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under EPA Enforcement Authority'",
    isIncluded: false,
    objectIds: null
  },
  "Long-term Cleanup Attention Needed/Ongoing under Local Government Program": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Local Government Program'",
    isIncluded: false,
    objectIds: null
  },
  "Long-term Cleanup Attention Needed/Ongoing under Other Federal Agency": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Other Federal Agency'",
    isIncluded: false,
    objectIds: null
  },
  "Long-term Cleanup Attention Needed/Ongoing under State Program": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under State Program'",
    isIncluded: false,
    objectIds: null
  },
  "Long-term Cleanup Attention Needed/Ongoing under Tribal Program": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Long-term Cleanup Attention Needed/Ongoing under Tribal Program'",
    isIncluded: false,
    objectIds: null
  },
  "Submitted to or Addressed by Superfund Removal Program": {
    param: "SF_NON_NPL_STATUS_SUBCATEG ='Submitted to or Addressed by Superfund Removal Program'",
    isIncluded: false,
    objectIds: null
  }
};

const AdvancedBasicSuperfundNonNPL = (props) => {
  const [checkboxDivArray, setCheckboxDivArray] = useState<Array<any>>([]);
  /* called every time a checkbox is checked or unchecked */
  const toggleParam = async (key) => {
    options[key].isIncluded = !options[key].isIncluded;
    passUpdatedParams();
  }

  // updates the brownfieldParam array stored in the parent component
  const passUpdatedParams = () => {
    let paramArray: Array<string> = [];
    for (let option in options) {
      if (options[option].isIncluded === true) {
        paramArray.push(options[option].param)
      }
    }
    // update the parameter stored in the parent component
    props.updateSuperfundNonNPLParams(paramArray);
  }

  const buildCheckboxDivs = (clear?) => {
    let tempArr: Array<any> = [];
    if (clear) {
      // the clear button was clicked, recreate checkboxes to be all unchecked
      for (let key in options) {
        options[key]["isIncluded"] = false;
        tempArr.push(
          <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
            <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
            <label className={styles.CheckboxLabels}>{key}</label>
          </div>
        );
      }
    } else {
      for (let key in options) {
        // clear button was not clicked, create checkboxes so that previously checked are still checked
        if (options[key]["isIncluded"] === true) {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox checked name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        } else {
          tempArr.push(
            <div className={styles.CheckboxAndLabelDivs} key={Math.random()}>
              <CalciteCheckbox name={options[key] + ' Box'} onCalciteCheckboxChange={() => { toggleParam(key) }} />
              <label className={styles.CheckboxLabels}>{key}</label>
            </div>
          );
        }
      }
    }
    passUpdatedParams();
    setCheckboxDivArray(tempArr);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(); }, [props.matchesAny]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { buildCheckboxDivs(true); }, [props.signalClear]);

  return (
    <div className={styles.Sections}>
      <div className={styles.SectionTitleDivs}>
        <label className={styles.FilterSectionLabels}>Superfund Non-NPL Sites</label>
      </div>
      <div className={styles.CheckboxSectionDivs}>
        {checkboxDivArray}
      </div>
    </div>
  );
}
export default AdvancedBasicSuperfundNonNPL;
